import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Button from '@karma/components/Button';
import { Stack } from '@karma/components';
import Alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';

const BaseLoadMore = ({ children, fetchMore, isFetching, left, buttonProps, ...props }) => {
  const { t } = useTranslation();
  const contextDataAttrs = Alooma.useContextDataAttrs();

  const onClickHandler = () => {
    if (!isFetching) {
      fetchMore();
    }
  };

  const buttonPropsDefault = {
    type: 'primary',
    size: 'medium',
    fullWidth: false,
    loading: isFetching,
    ...buttonProps,
  };

  return (
    <Stack spacing={38} direction="column" {...props}>
      {children}
      {left && (
        <Button
          onClick={onClickHandler}
          {...contextDataAttrs}
          data-alooma-element={ALOOMA.ELEMENTS.VIEW_MORE}
          {...buttonPropsDefault}
        >
          {t('app:viewMore')}
        </Button>
      )}
    </Stack>
  );
};

BaseLoadMore.propTypes = {
  children: PropTypes.node.isRequired,
  fetchMore: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  left: PropTypes.bool.isRequired,
  buttonProps: PropTypes.shape(),
};

BaseLoadMore.defaultProps = {
  buttonProps: {},
};

export default BaseLoadMore;
